<template>
  <v-container></v-container>
</template>

<script>
export default {
  name: 'AdminMasterQuantityConfirmEdit'
}
</script>

<style scoped>

</style>
